import Rate from "./components/vote_screen.vue";
import SLAuth from "./components/SLAuth.vue";
import Error from "./components/other/404.vue";
import SignUpScreen from "./components/widgets/SignUpScreen";
import Error_sticker from "./components/other/404_stickers.vue"
import serviceLogNoAccess from "./components/other/serviceLogNoAccess.vue"
import bobsSepticEvent from "./components/widgets/bobsSepticEvent";
import bobsSepticEventSecondScreen from "@/components/widgets/bobsSepticEventSecondScreen";
import bobsSepticEventFinalScreen from "@/components/widgets/bobsSepticEventFinalScreen";
import serviceLogHistory from "@/components/widgets/serviceLogHistory";

const ThankCreateNote = () => import("./components/other/thankCreateNote.vue");
const ServiceLogFinal = () => import("./components/other/serviceLogFinal.vue");

const routes = [
    {
        path: "/r/rate/:id",
        component: Rate,
        name: "Rate",
        meta: {
            checkIfVoted: true
        },
        children: [
            {
                name: "Rate-selected",
                path: ":number",
                component: Rate,
            },
        ]
    },
    {
        path: "/r/sl/:questionId/auth",
        component: SLAuth,
        name: "SLAuth",
        meta: {
            checkIfVoted: true
        },
    },
    {
        path: "/r/thank-for-vote/:questionId",
        component: ThankCreateNote,
        name: "ThanksCreateNote",
        children: [
            {
                name: "Rate-selected-Thank",
                path: ":number/:rateUid",
                component: ThankCreateNote
            }
        ]
    },
    {
        path: "/r/sign-up",
        component: SignUpScreen
    },
    {
        path: "/r/404",
        component: Error_sticker,
        name: "404_stickers",
    },
    {
        path: "/r/disabled",
        component: Error_sticker,
        name: "StickerDisabled",
    },
    {
        path: "/r/sl/no_access", //user logged in but doesn't have access to this question
        component: serviceLogNoAccess,
        name: "ServiceLogNoAccess",
    },
    {
        path: "/r/sl/:id", //service log direct route
        component: Rate,
        name: "ServiceLog",
    },
    {
        path: "/r/slf/:questionId/:rateUid", //service log final (after adding service log, same as ThankCreateNote for votes)
        component: ServiceLogFinal,
        name: "ServiceLogFinal",
    },
    {
        path: "/r/:questionId/bslead/:number",
        component: bobsSepticEvent,
        name: "bobsSepticEvent",

    },
    {
        path: "/r/bslead/2",
        component: bobsSepticEventSecondScreen,
        name:  "bobSepticEventSecondScreen"
    },
    {
        path: "/r/bslead/final",
        component: bobsSepticEventFinalScreen,
        name: "bobSepticFinalScreen"
    },
    {
        path: "/r/:questionId/sl",
        component: serviceLogHistory,
        name: "serviceLogHistory"
    },
    {path: "/*", component: Error, name: "404"}
];

export default routes;
